<script>
export default {
    data: function() {
        return {
            alerts: null,
            working: false
        }
    },
    methods: {
        valid: function() {
            if (this.alerts) this.alerts = null;
            this.$v.$touch();
            return !this.$v.$invalid;
        },
        submit: function(handler) {
            if (this.valid()) {
                this.working = true;
                handler();
            } else {
                this.$nextTick(_ => {
                    let elements = document.getElementsByClassName("has-error");

                    if (elements.length > 0) {
                        this.$scrollTo(elements[0])
                    }    
                });
            }
        },
        genericError: function(field) {
            return this.errorMessage(
                field, 
                'There was an error processing your request. Please try again later.'
            );
        },
        errorMessage: function(field, message) {
            let errors = {};

            errors[field] = [message];

            return errors;
        },
        genericErrorHandler: function(error) {
            window.scrollTo(0, 0);

            if (!error) {
                return this.alerts = this.genericError('email');
            }

            let response = error.status ? error : error.response;

            if (this.status !== undefined) {
                this.status = 'danger';
            }

            if (response && response.status === 422) {
                this.alerts = response.data.errors;
            } else if (response && response.status === 403) {
                this.alerts = this.errorMessage('email', 'Permission denied. Please contact administrator.');
            } else {
                this.alerts = this.genericError('email');
            }
        }
    }
}
</script>